const PIECES_TITLE = {
  "oil-filter": "فیلتر روغن",
  "oil-motor": "روغن موتور",
  "filter-room": "فیلتر اطاق",
  "filter-motor": "فیلتر موتور",
  glassCleaner: "شیشه‌شور",
  "filter-petrol": "فیلتر بنزین",
  battery: "باطری",
  radiatorWater: "رادیاتور",
  "engine-injector": "انژکتور",
  "engine-candle": "شمع",
  gearbox: "گیربکس",
  tire: "لاستیک",
  "brake-pad": "لنت ترمز",
  "engine-injection": "اینجکشن",
  "engine-wash": "موتورشویی",
  hydraulic: "هیدرولیک",
  collage: "کلاچ",
  suspension: "تعلیق",
  "engine-straps": "تسمه‌ها",
  catalyst: "کاتالیزور",
  cooler: "کولر",
  lamp: "برق",
  detailing: "دیتیلینگ",
  wrenching: "آچارکشی",
};
const PIECES_TITLETEXTMODE = {
  "oil-filter": "Mode_1",
  "oil-motor": "Mode_1",
  "filter-room": "Mode_1",
  "filter-motor": "Mode_1",
  glassCleaner: "Mode_1",
  "filter-petrol": "Mode_1",
  battery: "Mode_1",
  radiatorWater: "Mode_1",
  "engine-injector": "Mode_1",
  "engine-candle": "Mode_1",
  gearbox: "Mode_2",
  tire: "Mode_1",
  "brake-pad": "Mode_1",
  "engine-injection": "Mode_2",
  "engine-wash": "Mode_2",
  hydraulic: "Mode_2",
  collage: "Mode_2",
  suspension: "Mode_2",
  "engine-straps": "Mode_1",
  catalyst: "Mode_2",
  cooler: "Mode_2",
  lamp: "Mode_2",
  detailing: "Mode_2",
  wrenching: "Mode_2",
};
const PIECES_TERMSMODE = {
  "oil-filter": "short",
  "oil-motor": "short",
  "filter-room": "short",
  "filter-motor": "short",
  glassCleaner: "short",
  "filter-petrol": "short",
  battery: "short",
  radiatorWater: "short",
  "engine-injector": "mid",
  "engine-candle": "mid",
  gearbox: "mid",
  tire: "mid",
  "brake-pad": "mid",
  "engine-injection": "mid",
  "engine-wash": "mid",
  hydraulic: "mid",
  collage: "long",
  suspension: "long",
  "engine-straps": "long",
  catalyst: "long",
  cooler: "long",
  lamp: "long",
  detailing: "long",
  wrenching: "long",
};

const PIECES_REPLACETEXT = { Mode_1: "کیلومتر تعویض", Mode_2: "کیلومتر سرویس" };
const PIECES_REQUESTTEXT = { Mode_1: "عمر قطعه", Mode_2: "عمر سرویس" };

export {
  PIECES_TITLE,
  PIECES_TITLETEXTMODE,
  PIECES_TERMSMODE,
  PIECES_REPLACETEXT,
  PIECES_REQUESTTEXT,
};
